export default __webpack_public_path__ + "static/media/logoBlanco.fe8e7089.svg";